import { render, staticRenderFns } from "./settlementDetails.vue?vue&type=template&id=59ba0fba&scoped=true"
import script from "./settlementDetails.vue?vue&type=script&lang=js"
export * from "./settlementDetails.vue?vue&type=script&lang=js"
import style0 from "./settlementDetails.vue?vue&type=style&index=0&id=59ba0fba&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ba0fba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59ba0fba')) {
      api.createRecord('59ba0fba', component.options)
    } else {
      api.reload('59ba0fba', component.options)
    }
    module.hot.accept("./settlementDetails.vue?vue&type=template&id=59ba0fba&scoped=true", function () {
      api.rerender('59ba0fba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Settlement/settlementDetails.vue"
export default component.exports